import { useTranslation } from 'react-i18next';

// Resolver for the account's Country, which arrives as a raw ISO-3166 alpha-2 code and was being
// rendered as 'CA' / 'US' under a localized "Country" / "Pays" label. Same shape as
// useConnectionTypeLabels and partner-dashboard's own useCountryLabels: raw value is the logic key,
// an unmapped code falls back to itself.
//
// Shared keeps its own Countries keys rather than reading the hosts' Global.Countries. Both portals
// happen to have them, but shared reading a host-owned namespace would make its copy depend on
// whatever a future host chose to define — the same reason Shared.Buttons exists.
export default function useCountryLabels() {
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.Countries' });

  function getCountryLabel(country: string | undefined): string {
    if (!country) return '';

    return t(country, { defaultValue: country });
  }

  return { getCountryLabel };
}
